<template>
  <div style="width: 100%;height: 100%;overflow:auto;">
    <div style="width: 300px;font-size: 18px;margin-top: 10px"><b>实时数据：</b></div>
    <div style="display: flex;margin-top: 10px">
      <div v-for="(item,index) in cluePieList" style="width: 400px;height: 300px;" :id="'clue_' + index"></div>
    </div>

    <div style="display: flex;margin-top: 20px;margin-left: 10px">
      <div style="width: 300px;font-size: 18px;"><b>线索反馈数据：</b></div>
      <div style="width: 230px">
        <el-date-picker
            style="width:230px;"
            unlink-panels
            v-model="feedbackDate"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="initFeedbackData"
        />
      </div>
    </div>
    <div style="width: 98%;height: 300px;margin-top: 10px" id="clueFeedbackCnt"></div>
    <div style="width: 98%;height: 300px;" id="clueFeedbackRate"></div>

    <div style="display: flex;margin-top: 20px;margin-left: 10px">
      <div style="width: 300px;font-size: 18px;"><b>线索机会转化率：</b></div>
      <div style="width: 230px">
        <el-date-picker
            style="width:230px;"
            unlink-panels
            v-model="chanceChangeDate"
            type="daterange"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="initChanceChangeData"
        />
      </div>
    </div>

    <div style="width: 98%;height: 300px;margin-top: 10px" id="employeeTransform"></div>
    <div style="width: 98%;height: 300px;margin-top: 10px" id="sourceTransform"></div>


  </div>

</template>

<script>
import * as echarts from "echarts";

export default {
  name: "ClueData",

  data(){
    return{
      cluePieList:[],
      feedbackDate:null,
      feedbackCntLengthData:[],
      feedbackCntSeries:[],
      feedbackRateLengthData:[],
      feedbackRateSeries:[],
      chanceChangeDate:null,
      employeeLengthData:[],
      employeeSeries:[],
      sourceLengthData:[],
      sourceSeries:[]

    }
  },
  created() {

  },
  mounted() {
    this.initPieData();
    this.initFeedbackData();
    this.initChanceChangeData();

  },

  methods:{

    async initPieData(){
      await this.getPieData();
      for (let item of this.cluePieList){
        let index = this.cluePieList.indexOf(item);
        let name = item.name;
        await this.renderEcharts(item.data, name, index);
      }
    },
    async getPieData(){
      this.cluePieList = await this.$http('crmBusinessService.getCluePieData');
    },

    async initFeedbackData(){
      let params = {startDate:this.feedbackDate?.[0],endDate:this.feedbackDate?.[1]};
      let data = await this.$http('crmBusinessService.getClueFeedbackCntData',params);
      this.feedbackCntLengthData = data?.lengthData;
      this.feedbackCntSeries = data?.seriesData;
      let rateData = await this.$http('crmBusinessService.getClueFeedbackRateData',params);
      this.feedbackRateLengthData = rateData?.lengthData;
      this.feedbackRateSeries = rateData?.seriesData;
      this.initFeedbackEcharts();
    },

    async initChanceChangeData(){
      let params = {startDate:this.chanceChangeDate?.[0],endDate:this.chanceChangeDate?.[1]};
      let chanceData = await this.$http('crmBusinessService.getChanceChangeData',params);
      this.employeeLengthData = chanceData?.lengthData;
      this.employeeSeries = chanceData?.seriesData;
      let sourceData = await this.$http('crmBusinessService.getSourceChangeData',params);
      this.sourceLengthData = sourceData?.lengthData;
      this.sourceSeries = sourceData?.seriesData;
      this.initChanceChangeEcharts();
    },

    renderEcharts(data,name,index){
      const clueStatusChartDom = document.getElementById('clue_'+index);
      // 获取现有的 ECharts 实例（如果有）
      let clueStatusChart = echarts.getInstanceByDom(clueStatusChartDom);
      // 如果存在现有的实例，销毁它
      if (clueStatusChart) {
        clueStatusChart.dispose();
      }
      // 初始化新的 ECharts 实例
      clueStatusChart = echarts.init(clueStatusChartDom);
      clueStatusChart.setOption(this.getClueStatusChartOptions(data,name), true);
    },
    initFeedbackEcharts(){
      //-----------------------反馈数----------------
      const clueFeedbackCntChartDom = document.getElementById('clueFeedbackCnt');
      // 获取现有的 ECharts 实例（如果有）
      let clueFeedbackCntChart = echarts.getInstanceByDom(clueFeedbackCntChartDom);
      // 如果存在现有的实例，销毁它
      if (clueFeedbackCntChart) {
        clueFeedbackCntChart.dispose();
      }
      // 初始化新的 ECharts 实例
      clueFeedbackCntChart = echarts.init(clueFeedbackCntChartDom);
      clueFeedbackCntChart.setOption(this.getClueFeedbackCntChartOptions(), true);

      //----------------反馈率----------------
      const clueFeedbackRateChartDom = document.getElementById('clueFeedbackRate');
      // 获取现有的 ECharts 实例（如果有）
      let clueFeedbackRateChart = echarts.getInstanceByDom(clueFeedbackRateChartDom);
      // 如果存在现有的实例，销毁它
      if (clueFeedbackRateChart) {
        clueFeedbackRateChart.dispose();
      }
      // 初始化新的 ECharts 实例
      clueFeedbackRateChart = echarts.init(clueFeedbackRateChartDom);
      clueFeedbackRateChart.setOption(this.getClueFeedbackRateChartOptions(), true);
    },

    initChanceChangeEcharts(){
      //-----------------------员工转化率----------------
      const employeeChartDom = document.getElementById('employeeTransform');
      // 获取现有的 ECharts 实例（如果有）
      let employeeChart = echarts.getInstanceByDom(employeeChartDom);
      // 如果存在现有的实例，销毁它
      if (employeeChart) {
        employeeChart.dispose();
      }
      // 初始化新的 ECharts 实例
      employeeChart = echarts.init(employeeChartDom);
      employeeChart.setOption(this.getEmployeeChartOptions(), true);

      //----------------来源转化率----------------
      const sourceChartDom = document.getElementById('sourceTransform');
      // 获取现有的 ECharts 实例（如果有）
      let sourceChart = echarts.getInstanceByDom(sourceChartDom);
      // 如果存在现有的实例，销毁它
      if (sourceChart) {
        sourceChart.dispose();
      }
      // 初始化新的 ECharts 实例
      sourceChart = echarts.init(sourceChartDom);
      sourceChart.setOption(this.getSourceChartOptions(), true);
    },
    getClueStatusChartOptions(data,name){
      const total = data.reduce((sum, item) => sum + item.value, 0);
      return{
        title: {
          text: name + '：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          type: 'scroll',
          top: 'bottom',
          left: 'center'
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '线索数\n' + total,
            textAlign: 'center',
            fontSize: 20,
            fill: '#0074e0',
          },
        },
        label: {
          show: true, // 显示标签
          formatter: function (params) {
            // 计算占比
            const percent = ((params.value / total) * 100).toFixed(2);
            if(total === 0.0 || total === undefined){
              return '0%';
            }
            return `${percent}%`;
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['35%', '50%'],
            data: data === undefined ? [] : data,
          }
        ]
      }
    },
    getClueFeedbackCntChartOptions(){
      return {
        title: {
          text: '反馈数：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.feedbackCntLengthData
        },
        yAxis: {
          type: 'value'
        },
        series: this.feedbackCntSeries
      }
    },
    getClueFeedbackRateChartOptions(){
      return {
        title: {
          text: '反馈率：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend:{
          top: '10px',
          left: 'center'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.feedbackRateLengthData
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: this.feedbackRateSeries.map(item => ({
          ...item, // 保留原数据
          label: {
            show: true,
            position: 'top',
            formatter: function (params) {
              // 直接拼接 % 符号
              return `${params.value}%`;
            }
          }
        }))
      }
    },
    getEmployeeChartOptions(){
      return {
        title: {
          text: '员工转化率：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend:{
          top: '10px',
          left: 'center'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.employeeLengthData
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: this.employeeSeries.map(item => ({
          ...item, // 保留原数据
          label: {
            show: true,
            position: 'top',
            formatter: function (params) {
              // 直接拼接 % 符号
              return `${params.value}%`;
            }
          }
        }))
      }
    },
    getSourceChartOptions(){
      return {
        title: {
          text: '来源转化率：',
          textStyle: {
            fontSize: 15, // 设置字体大小为 15px
            color: '#0074e0',
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend:{
          top: '10px',
          left: 'center'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.sourceLengthData
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: this.sourceSeries.map(item => ({
          ...item, // 保留原数据
          label: {
            show: true,
            position: 'top',
            formatter: function (params) {
              // 直接拼接 % 符号
              return `${params.value}%`;
            }
          }
        }))
      }
    }

  }
}
</script>

<style scoped>

</style>